module.exports = __webpack_public_path__ + "media/assets/images/flags/hk-985a32ca601f821f502cab655933a726.svg";